export const pdfWorkerUrl =
  typeof window !== 'undefined'
    ? `${window.location.origin}/pdf.worker.min.mjs`
    : '/pdf.worker.min.mjs';
